/**
 * Golf FS IRONS Reducers
 */
import {
    FSIRONS_ACTION,
    ALL_FSIRONS,
    ADD_FSIRONS,
    FETCH_FSIRONS,
    EDIT_FSIRONS,
    DELETE_FSIRONS
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    fsironslist:[],
    particularfsirons:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case FSIRONS_ACTION:
            return { ...state, loading: true };       

        case ALL_FSIRONS:
            return { ...state, loading: false, fsironslist: action.payload };     
            
        case ADD_FSIRONS:
            return { ...state, loading: false };     
         
        case FETCH_FSIRONS:
            return { ...state, loading: false, particularfsirons: action.payload };  
            
        case EDIT_FSIRONS:
            return { ...state, loading: false }; 
            
        case DELETE_FSIRONS:
            return { ...state, loading: false };     
        
        default: return { ...state };

     }
 }